import { render } from "./CarouselAdvert.vue?vue&type=template&id=6f779df0"
import script from "./CarouselAdvert.vue?vue&type=script&lang=js"
export * from "./CarouselAdvert.vue?vue&type=script&lang=js"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__